import '../../stylesheets/_custom.scss'

import '../../stylesheets/general.styl'
import '../../stylesheets/navbar.styl'
import '../../stylesheets/footer.styl'
import '../../stylesheets/gb-operator/index.styl'

import '../navbar.js'

// Cart already includes Google Analytics
import '../cart.js'

import { supportsHEVCAlpha, isIOSChrome, isSafari } from '../video-compat.js'
import { setCookie, getCookie, removeCookie } from 'tiny-cookie'

const smallPlayer = document.querySelector("#small-player");
const largePlayer = document.querySelector("#large-player");

if (isSafari && !supportsHEVCAlpha() || isIOSChrome && !supportsHEVCAlpha()) {
  smallPlayer.src = supportsHEVCAlpha() ? path + 'render.mov' : path + 'render.mp4';
  largePlayer.src = supportsHEVCAlpha() ? path + 'render.mov' : path + 'render.mp4';
}
